import { type Flow } from '../types';
import { findNextPaths } from './findNextPaths';

export async function findNextPath<S>(
  flow: Flow<S>,
  state: S,
  currentPath: string,
  stopAtPath?: string
): Promise<string> {
  return (
    (
      await findNextPaths(
        flow,
        state,
        currentPath,
        stopAtPath ? { option: 'stop_at', path: stopAtPath } : undefined
      )
    ).pop() || currentPath
  );
}
